<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14f41hf/tc-custom/9798368825090.jpg?1743796231158" alt="This image is the cover for the book C.O.W.L. 1964 #1, C.O.W.L. 1964"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">C.O.W.L. 1964 #1, C.O.W.L. 1964
      </h1>
      <p class="bookDescription body article font2">
        <p>MINISERIES PREMIEREIt’s 1964, and C.O.W.L. - the Chicago Organized Workers League, the world’s first superhero labor union-is going national! But with the old team scattered and powerful forces moving in the shadows, will this union be busted before it gets off the ground?Join the original C.O.W.L. creative team of KYLE HIGGINS (RADIANT BLACK), ALEC SIEGEL (HADRIAN’S WALL), and ROD REIS (New Mutants) for a new miniseries; celebrating C.O.W.L.’s 10-year anniversary!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kyle Higgins, Alec Siegel, Rod Reis
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Image Comics
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3b3b98b4